import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanResourcesListItem } from "../../../types";

const ScanResourcesTableSettingsCell = (props: TableSimpleCellProps<ScanResourcesListItem>) => (
  <TableSimpleCell {...props} />
);

export default ScanResourcesTableSettingsCell;
